export default __webpack_public_path__ + "static/media/29-JustSantorini.02eb252b.jpeg";